import React, { useState } from "react";
import { Link } from "react-router-dom";

// Import your images and videos
import Quicktwo from "../images/quick-servie/quicktwo.jpg";
import Quickone from "../images/quick-servie/quickone.jpg";
// import PlayButton from "../images/gif/play-gif-unscreen.gif";
// import ServuceThree from "../images/quick-servie/servicethree.jpg";

// Power Tools image imports
import ServiceEight from "../images/quick-servie/serviceeight.webp";
import ServiceFive from "../images/quick-servie/servicefive.jpg";
import ServiceFour from "../images/quick-servie/servicefour.jpg";
import ServiceOne from "../images/quick-servie/serviceone.jpg";
import ServiceSeven from "../images/quick-servie/serviceseven.jpg";
import ServiceSix from "../images/quick-servie/servicesix.jpg";
import ServiceTwo from "../images/quick-servie/servidetwo2.jpeg";
import "../components/Section/car.css";

// Example powder coating items (both images and videos)
// const powderCoatingItems = [
//   {
//     id: 1,
//     name: "Oil Change",
//     img: ServiceTwo,
//     type: "image",
//   },
//   {
//     id: 2,
//     name: "Battery service",
//     img: ServiceOne,
//     type: "image",
//   },
//   {
//     id: 3,
//     name: "Tire service",
//     img: ServuceThree,
//     type: "image",
//   },
//   {
//     id: 4,
//     name: "Brake and suspension",
//     img: ServuceThree,
//     type: "image",
//   },
//   {
//     id: 5,
//     name: "Transmission Repairs",
//     img: ServiceFour,
//     type: "image",
//   },
//   {
//     id: 6,
//     name: "Engine Dignostic service",
//     img: ServiceSix,
//     type: "image",
//   },
//   {
//     id: 7,
//     name: "Air Filter ",
//     img: ServiceSeven,
//     type: "image",
//   },
//   {
//     id: 8,
//     name: "Lights Services",
//     img: ServiceEight,
//     type: "image",
//   },
// ];

function AktPowdercoating() {
  const [selectedVideo, setSelectedVideo] = useState(null);

  // const openModal = (item) => {
  //   if (item.type === "video") {
  //     setSelectedVideo(item);
  //     document.body.style.overflow = "hidden";
  //   }
  // };

  const closeModal = () => {
    setSelectedVideo(null);
    document.body.style.overflow = "auto";
  };

  return (
    <div className="bg-[#0C2341] mx-4 min-h-screen mt-2">
      <div className="w-full">
        {/* Top Section - Image & Text */}
        <div className="mx-auto md:mt-3">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 items-stretch">
            {/* Left Side - Image */}
            <div className="lg:col-span-5 rounded-lg duration-300 ease-in-out flex flex-col justify-center md:h-[400px]">
              <div className="w-full h-[400px] overflow-hidden rounded-lg">
                <img
                  src={Quickone}
                  alt="Powder Coating Facility"
                  className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
                />
              </div>
            </div>

            {/* Right Side - Image */}
            <div className="lg:col-span-7 flex">
              <div className="w-full h-[400px] overflow-hidden rounded-lg">
                <img
                  src={Quicktwo}
                  alt="Powder Coating Process"
                  className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col md:flex-row bg-[#0c2341] text-white">
        <main className="w-full">
          {/* AKT QUICK SERVICE - Text Content */}
          <div className="lg:col-span-5 bg-white text-[#0c2340] p-6 mt-4 rounded-lg duration-300 ease-in-out flex flex-col justify-center md:h-[200px]">
            <h2 className="text-2xl md:text-4xl font-bold mb-2  text-center">
              AKT QUICK SERVICE
            </h2>
            <p className="text-sm md:text-lg md:mt-1 mb-6 text-justify">
              AKT Quick Services offers fast, reliable car maintenance and repair solutions, including routine servicing, oil changes, and mechanical repairs. With skilled technicians and quality parts, AKT ensures efficient, professional care to keep your vehicle running smoothly and safely. Their services focus on convenience and expert support, making AKT a trusted choice for quick automotive care without compromising on quality.
            </p>
          </div>
          <h1 className="text-base md:text-2xl md:mb-3 py-2">
            <Link to="/">Home</Link> / AKT AUTOMOTIVE{" "}
            <span className="font-bold"></span>
          </h1>

          <h1 className="text-2xl md:text-4xl font-bold">
            QUICK SERVICES
          </h1>
          <div className="w-full overflow-hidden font-sans text-gray-800 !bg-[#ffffff]">
            <div className="py-6">
              <div className="bg-white rounded-xl">
                {/* Sections */}
                <div className="space-y-12">
                  {/* Section 1 */}
                  <div className='text-center max-w-3xl mx-auto'>
                    <h2
                      className="text-3xl font-bold tracking-widest"
                      style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                    >
                      OUR QUICK SERVICES
                    </h2>
                  </div>
                  <div className="md:flex items-center justify-center">
                    <img src={ServiceTwo} alt="Preparation" className="md:w-1/2 w-full rounded-lg" />
                    <div className="md:w-1/3 w-full p-10 bg-white shadow-lg text-center justify-center">
                      <h2
                        className="text-2xl font-bold tracking-widest p-8"
                        style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                      >
                        OIL CHAGNE
                      </h2>
                      <p className="text-lg sm:text-xl text-gray-800 leading-relaxed text-justify">

                        We use only the highest quality lubricants to reduce engine friction and wear, extending your vehicle’s lifespan. Visit AKT today and let your engine perform at its peak, guaranteeing a smooth ride every time.

                        With a Car Repair Service oil change, or any other service, you’ll receive a Touch® Courtesy Check. We’ll look inside, outside, under the hood and underneath the car, then explain the findings and give you a written report.

                        Our oil change service ensures that your vehicle receives the highest quality oil, tailored to its specific needs.
                      </p>
                    </div>
                  </div>

                  {/* Section 2 */}
                  <div className="md:flex md:flex-row-reverse items-center justify-center px-4 py-4">
                    <img src={ServiceOne} alt="Non-invasive" className="md:w-1/2 w-full rounded-lg" />
                    <div className="md:w-1/3 w-full p-8 bg-white shadow-lg text-center justify-center">

                      <h2
                        className="text-2xl font-bold tracking-widest p-8"
                        style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                      >
                        BATTERY SERVICES
                      </h2>
                      <p className="text-lg sm:text-xl text-gray-800 leading-relaxed text-justify">Our philosophy is not to remove any body panels, parts, wing mirrors or lights when applying PPF.
                        Your vehicle’s battery is essential for reliable performance, and at AKT, we provide expert battery services to keep your car running smoothly. Whether you need a battery replacement or routine maintenance, our team is here to help.
                        Our Battery Services Include : Battery Replacement and Battery Service.
                      </p>
                    </div>
                  </div>
                  <div className="md:flex items-center justify-center">
                    <img src={ServiceFive} alt="Preparation" className="md:w-1/2 w-full rounded-lg" />
                    <div className="md:w-1/3 w-full p-10 bg-white shadow-lg text-center justify-center">
                      <h2
                        className="text-2xl font-bold tracking-widest p-8"
                        style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                      >
                        BREAK AND SUSPENSION
                      </h2>
                      <p className="text-lg sm:text-xl text-gray-800 leading-relaxed text-justify">
                        Ensure your vehicle’s safety with AKT’s expert brake services, including inspections, pad replacements, rotor resurfacing, fluid flushing, and caliper servicing.
                        Our skilled technicians use high-quality parts to deliver fast, reliable maintenance that keeps your braking system in top condition.
                        From front and rear brake pad changes to complete caliper overhauls, we cover all your brake repair needs. Trust AKT for responsive, smooth, and safe braking performance—visit us today.
                      </p>
                    </div>
                  </div>

                  {/* Car Detailing */}
                  <section className="relative w-full h-[100vh] p-4">
                    <img src={ServiceFour} alt="Hero" className="absolute inset-0 w-full h-full object-cover" />
                    <div className="absolute inset-y-0 right-0 flex items-center justify-end pr-10">
                      <div className="px-6 py-6 text-center rounded-md max-w-3xl text-white">
                        <h2
                          className="text-2xl sm:text-4xl font-bold tracking-widest mb-4"
                          style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                        >
                          TRANSMISSION REPAIRS
                        </h2>
                        <p className="text-lg sm:text-xl leading-relaxed">
                          Keep your vehicle running smoothly with AKT’s expert transmission repair services, including diagnostics, fluid replacement, clutch repair, and complete rebuilds.
                          Our certified technicians quickly identify and fix transmission issues to restore peak performance and prevent costly breakdowns.
                          Whether it's an automatic or manual transmission, we use top-grade parts for lasting reliability. Trust AKT for smooth shifting, improved fuel efficiency, and dependable driving.
                        </p>
                      </div>
                    </div>
                  </section>


                  {/* Window Tint */}
                  <div className="md:flex md:flex-row-reverse items-center justify-center px-4 py-4">
                    <img src={ServiceSix} alt="Our Prep" className="md:w-1/2 w-full rounded-lg" />
                    <div className="md:w-1/3 w-full p-8 bg-white text-center justify-center shadow-2xl">
                      <h2
                        className="text-2xl font-bold tracking-widest p-8"
                        style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                      >
                        ENGINE DIGNOSTIC SERVICE
                      </h2>
                      <p className="text-lg sm:text-xl text-gray-800 leading-relaxed text-justify">
                        Ensure peak engine performance with AKT’s professional engine diagnostic service, using advanced tools to detect issues early and accurately.
                        Our expert technicians identify problems like misfires, sensor faults, and performance drops before they become major repairs.
                        We provide clear reports and recommend only necessary fixes to keep your engine running efficiently. Trust AKT for reliable diagnostics, better fuel economy, and a smoother drive
                      </p>
                    </div>
                  </div>
                  <div className="md:flex items-center justify-center px-4 py-4">
                    <img src={ServiceEight} alt="Durability" className="md:w-1/2 w-full rounded-lg" />
                    <div className="md:w-1/3 w-full p-8 bg-white shadow-lg text-center justify-center">
                      <h2
                        className="text-2xl font-bold tracking-widest p-8"
                        style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                      >
                        LIGHT SERVICE
                      </h2>
                      <p className="text-lg sm:text-xl text-gray-800 leading-relaxed text-justify">
                        Drive safely and confidently with AKT’s professional light service, covering headlights, brake lights, indicators, and interior lighting.
                        Our technicians inspect, replace, and align all vehicle lights to ensure maximum visibility and compliance with road safety standards.
                        Whether it's a bulb replacement or wiring issue, we use quality components for long-lasting results. Trust AKT to keep your vehicle well-lit and road-read.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Window Tint */}
                <div className="md:flex md:flex-row-reverse items-center justify-center px-4 py-4">
                  <img src={ServiceSeven} alt="Our Prep" className="md:w-1/2 w-full rounded-lg" />
                  <div className="md:w-1/3 w-full p-8 bg-white text-center justify-center shadow-2xl">
                    <h2
                      className="text-2xl font-bold tracking-widest p-8"
                      style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                    >
                      Air Filter
                    </h2>
                    <p className="text-lg sm:text-xl text-gray-800 leading-relaxed text-justify">
                      Breathe cleaner and drive better with AKT’s air filter service, designed to boost engine efficiency and cabin air quality.
                      Our technicians inspect and replace clogged engine and cabin air filters to ensure optimal airflow and performance.
                      A clean filter improves fuel economy, reduces emissions, and protects vital engine components. Visit AKT today for a quick, professional air filter check and replacement you can trust.
                    </p>

                  </div>
                </div>

                {/* <div className="mx-auto px-4 py-10 sm:px-10 sm:py-14">
                <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                  {powderCoatingItems.map((item) => (
                    <div
                      key={item.id}
                      className="group block overflow-hidden rounded-2xl shadow-2xl hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-gradient-to-br from-white to-gray-50 cursor-pointer"
                      onClick={() => openModal(item)}
                    >
                      <div className="relative">
                        <div className="w-full h-64 overflow-hidden">
                          <img
                            src={item.img}
                            alt={item.name}
                            className="w-full h-full object-cover transition-opacity duration-300 rounded-t-2xl"
                          />
                          {item.type === "video" && (
                            <div className="absolute inset-0 flex items-center justify-center">
                              <img
                                src={PlayButton}
                                alt="Play Button"
                                className="h-20 rounded-full bg-black/45 hover:bg-[#0c2340]"
                              />
                            </div>
                          )}
                        </div>
                        <div className="px-4 py-3 text-center">
                          <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800 group-hover:text-blue-600 transition duration-300 tracking-wide">
                            {item.name}
                          </h3>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div> */}
              </div>
            </div>
          </div>
        </main>
      </div>

      {/* Video Modal */}
      {selectedVideo && (
        <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4">
          <div className="relative bg-black rounded-xl overflow-hidden max-w-3xl w-full aspect-video shadow-2xl">
            <video
              src={selectedVideo.videoUrl}
              controls
              autoPlay
              playsInline
              controlsList="nodownload noremoteplayback"
              disablePictureInPicture
              onContextMenu={(e) => e.preventDefault()}
              className="w-full h-full object-contain"
            />
            <button
              onClick={closeModal}
              className="absolute top-1 right-1 text-white bg-red-500 hover:bg-red-600 rounded-lg p-2 text-sm"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default AktPowdercoating;